import React from 'react';

const ResidenceCardPlaceholder = () => {
  return (
    <div className="placeholder-rc color-white">
      <div className="placeholder-rc__img animation" />
      <div className="placeholder-row placeholder-row--mt--10 placeholder-rc__title animation" />
      <div className="placeholder-row placeholder-row--mt--10 placeholder-rc__developer animation" />
      <div className="placeholder-row placeholder-row--mt--10 placeholder-rc__location animation" />
      <div className="placeholder-row placeholder-row--mt--10 placeholder-rc__metro animation" />
      <div className="placeholder-row placeholder-row--mb--20 placeholder-rc__deadline animation" />
    </div>
  );
};

export default ResidenceCardPlaceholder;
